module.exports = __webpack_public_path__ + "static/media/comingSoon.deaf9e99.png";